export default {
  GET_SEARCH_BY_CUSTOMER_QUERY: Symbol.for('GET_SEARCH_BY_CUSTOMER_QUERY'),
  SEARCH_BY_CUSTOMER_REPOSITORY: Symbol.for('SEARCH_BY_CUSTOMER_REPOSITORY'),
  SEARCH_BY_CUSTOMER_STATE_MANAGER: Symbol.for('SEARCH_BY_CUSTOMER_STATE_MANAGER'),
  GET_ACTIVE_GOAL_AMOUNT_BY_FUND_TYPE_QUERY: Symbol.for('GET_ACTIVE_GOAL_AMOUNT_BY_FUND_TYPE_QUERY'),
};
